/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_DisabledInputs */

const cs_auth_signup_disabled = /** @type {(inputs: Auth_Signup_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejná registrace je vypnutá. Požádejte o pozvánku od administrátora.`)
};

const en_auth_signup_disabled = /** @type {(inputs: Auth_Signup_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public signup is disabled. Ask an administrator for an invite.`)
};

/**
* | output |
* | --- |
* | "Public signup is disabled. Ask an administrator for an invite." |
*
* @param {Auth_Signup_DisabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_disabled = /** @type {((inputs?: Auth_Signup_DisabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_DisabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_disabled(inputs)
	return cs_auth_signup_disabled(inputs)
});